<template>
    <div>
        <input type="hidden" v-bind:value="formElement.dynamicTypeData.value" />
    </div>
</template>

<script>
export default {
  name: "kollecto-hidden",
  props: ["formElement"]
};
</script>
